export type Bonus = {
  id: string
  title: string
  intro: string[]
  situations?: string[]
  listLabel: string
  bullets: string[]
  flow: { label?: string; steps: string[] }
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'Guide des Corrections Techniques en Danse Classique',
    intro: [
      'Une ressource pratique pour identifier les erreurs techniques, comprendre leurs causes possibles et sélectionner une correction adaptée.',
    ],
    listLabel: 'Le guide couvre notamment :',
    bullets: [
      'posture',
      'alignement',
      'turnout',
      'bassin',
      'pieds',
      'bras',
      'équilibre',
      'travail à la barre',
      'centre',
      'pirouettes',
      'tours',
      'sauts',
      'réception',
    ],
    flow: { steps: ['Identifier', 'Comprendre', 'Corriger', 'Réévaluer'] },
  },
  {
    id: '02',
    title: 'Progressions Techniques par Niveau en Danse Classique',
    intro: [],
    listLabel: 'Une structure pédagogique pour savoir :',
    bullets: [
      'quoi enseigner',
      'dans quel ordre',
      'quels prérequis observer',
      'quand augmenter la difficulté',
      'quand revenir à une étape précédente',
    ],
    flow: {
      label: 'Progression :',
      steps: ['Débutant', 'En progression', 'Intermédiaire'],
    },
  },
  {
    id: '03',
    title: 'Bibliothèque de Consignes Pédagogiques pour Professeurs de Ballet',
    intro: [
      'Une bibliothèque de formulations pour vous aider à communiquer plus clairement les corrections techniques.',
    ],
    listLabel: 'Vous trouverez des consignes liées à :',
    bullets: [
      'posture',
      'placement',
      'turnout',
      'pieds',
      'bras',
      'équilibre',
      'spotting',
      'tours',
      'sauts',
      'coordination',
      'musicalité',
    ],
    flow: {
      steps: [
        'Observer',
        'Choisir une priorité',
        'Donner une consigne',
        'Faire répéter',
        'Réévaluer',
      ],
    },
  },
  {
    id: '04',
    title: 'Système d’Évaluation & Suivi des Élèves en Danse Classique',
    intro: [
      'Une méthode structurée pour observer la progression technique sans transformer chaque cours en examen.',
    ],
    listLabel: 'Évaluez notamment :',
    bullets: [
      'posture',
      'alignement',
      'coordination',
      'équilibre',
      'barre',
      'centre',
      'pirouettes',
      'tours',
      'sauts',
      'musicalité',
      'autonomie',
    ],
    flow: {
      label: 'Progression :',
      steps: [
        'À construire',
        'En développement',
        'Maîtrisé',
        'Solide et autonome',
      ],
    },
  },
  {
    id: '05',
    title: '30 Plans de Cours d’Urgence pour Danse Classique',
    intro: ['Une ressource conçue pour les jours où vous manquez de temps.'],
    situations: [
      'Remplacement.',
      'Changement de groupe.',
      'Cours supplémentaire.',
      'Séance de dernière minute.',
    ],
    listLabel:
      'Vous disposez de plans pour différentes durées et différents niveaux :',
    bullets: [
      '30 minutes',
      '45 minutes',
      '60 minutes',
      'débutantes',
      'élèves en progression',
      'intermédiaires',
      'barre',
      'centre',
      'pirouettes',
      'sauts',
      'révision technique',
    ],
    flow: {
      label: 'Pas le temps de préparer ?',
      steps: ['Ouvrir', 'Choisir', 'Enseigner'],
    },
  },
]
